// action types
export const SELECT_CONTACT = 'SELECT_CONTACT'
export const SELECT_PROJECT = 'SELECT_PROJECT'
export const STORE_STATUS_TAB = 'STORE_STATUS_TAB'
export const STORE_TABLE_PAGE = 'STORE_TABLE_PAGE'

// action creators
export const selectContact = (action, id = null) => {
  return {
    type: SELECT_CONTACT,
    payload: { action, id }
  }
}

export const selectProject = (action, id = null) => {
  return {
    type: SELECT_PROJECT,
    payload: { action, id }
  }
}

export const storeStatusTab = statusTab => {
  return {
    type: STORE_STATUS_TAB,
    payload: { statusTab }
  }
}

export const storeTablePage = page => {
  return {
    type: STORE_TABLE_PAGE,
    payload: { page }
  }
}



// WEBPACK FOOTER //
// ./src/actions/nav.js